<template>
  <div id="app">
    <router-view></router-view>
    <mu-dialog :open="dialog" dialogClass="notice-dialog" title="">
      <notice></notice>
    </mu-dialog>
  </div>
</template>

<script>
var store = require('./app/store.js');
import {applyRouteTemplate} from './router/utils.js'
import notice from './components/service/notice/notice.vue'
import {getData} from '../src/assets/js/common.js';
export default {
  data() {
      return {
        dialog:true,
        isShowNotice:localStorage.getItem('showNotice'),
        locat:true, //判断路由来源
      }
  },
  mounted(){
    // this.toRefresh();
    this.getAccount();
    this.checkNotice();
  },
  components: {
      notice
    },
  methods:{
    checkNotice(){
      if(this.isShowNotice){
        this.dialog=false;
        this.toRefresh();
      }else{
        localStorage.setItem("showNotice", 1);
      }
    },
    getUserMe(token){
      if(this.locat){
        return new Promise((res,rej) => {
          getData('/api/Users/me', function(){
            res(JSON.parse(arguments[0]));
          },token)
        })
      }else{
        return this.$http.get('/api/Users/me')
      }
    },
    toRefresh: function(){
      let request = new XMLHttpRequest()
      // 第三个参数 false 代表设置同步请求
      request.open('GET', '/api/Script/version?branch=DOCTOR', false);
      request.setRequestHeader('Accept', 'application/json');
      request.setRequestHeader('Content-Type', 'application/json');
      request.send();
      if (request.status === 200 && request.readyState == 4) {
        let backV = JSON.parse(request.response).version;
        console.log(__webpack_hash__)
        if(false === SKIP_RELOAD && backV != __webpack_hash__){
          window.location.reload(true);
        }
        // console.log(JSON.parse(request.response).version)
      }
    },
    getAccount: function () 
    {
      var token = localStorage.getItem('access_token');
      console.log(window.location.hash);
      if (token) 
      {
        this.getUserMe(token)
        .then((res) => 
        {
            console.log(res);
            this.$store.commit("getUsersMe",res);
            var apiUrl = `/api/v2/users/${res.username}/available-routes/doctor`;
            this.$http.get(apiUrl)
            //组装路由并跳转
            .then((res)=>
            {
              if (false == res)
              {
                return;
              }
              let new_routes = res.data;
              console.log(res.data);
              let brainStatus = { path: '/brainStatus/:id', component: "brainStatus", name:'brainStatus' };
              /* let errorPage={path:'/errorPage',component:'errorPage',name:'errorPage'};
              let noPage = {path: '*', component: "noPage", name: "noPage"};
              let timeoutPage = {path: '*', component: "timeoutPage", name: "timeoutPage"}; */
              new_routes[0].children[1].children.push(brainStatus);
              /* new_routes.push(timeoutPage);
              new_routes.push(errorPage);
              new_routes.push(noPage); */
              applyRouteTemplate(new_routes);
              this.$router.addRoutes(new_routes);
            })
            store.setAccount(res);
        }, 
        function(err)
        {
          console.log(err)
        });
      }else{
        //清空缓存刷新时触发404从而回到首页
        if(window.location.hash == '#/'){
          this.getUserMe(token).then((res)=>{
            console.log(res);
          },(err)=>{
            console.log(err);
          })
        }else{
          this.$http.get('/api/Users/me').then((res)=>{
            console.log(res);
          },(err)=>{
            console.log(err);
          })
        }
      }
    }
  }
}
</script>

<style lang="stylus">
	#app
		height 100%
    a.u-link--Active div {
      background-color #f5f5f5
    }
</style>
<style>
/*
.mu-dialog.notice-dialog{
    width:768px ;
    max-width:768px ;
    max-height:800px ;
  }
  */
  
.mu-dialog.notice-dialog{
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: stretch;
  flex-grow: 1;
  height: 65vh;
  
}
.mu-dialog.notice-dialog .mu-dialog-body {
  display: flex;
  flex-grow: 1;
  justify-content: stretch;
  align-items: stretch;
  flex-direction: column;
}
.mu-dialog.notice-dialog .mu-dialog-body>div {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
}

.mu-dialog.notice-dialog .mu-dialog-body iframe{
  flex-grow: 1;
}
@media (-webkit-max-width: 1280px) and (-webkit-min-width: 1024px),(max-width:1280px) and (min-width:1024px){
    .notice-dialog{
    width:768px !important;
    max-width:768px !important;
    /* height:544px !important; */
    /* max-height:544px !important; */
    max-height:404px !important;
  }
}

@media (-webkit-max-width: 1024px),(max-width:1024px){
    .notice-dialog{
    width:768px !important;
    max-width:768px !important;
    /* height:544px !important;
    max-height:544px !important; */
    max-height:404px !important;
  }
}
</style>




// WEBPACK FOOTER //
// App.vue?185ad732